<div class="band bg-black">
    <div class="container">
        <div class="row masthead__banner">
            <div class="col-sm-6 col-md-5 col-lg-4">
                <h1 class="masthead-title" [innerHtml]="businessFunction?.headerText"></h1>
                <p class="masthead-introduction">
                    {{ businessFunction?.displayName }}
                </p>
                <p class="masthead-byline" [innerHtml]="businessFunction?.overviewText"></p>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <!-- 15-5-2025 : Exclude Email Digest feature from the list Temporary code change-->
    <!--<div class="row" [hidden] ="!hasSubscription">
    <div class="col-md-12">
      <div class="pt-lg-5 text-md-right">
        <button class="btn btn-info" (click)="onShowSubscription($event)">Email Digest  <i class="fa fa-bell"></i></button>
      </div>
    </div>
    <hr>
    </div>-->

    <div class="row">
        <div id="updatecontainer" class="col-md-5 mt-5">
            <p class="h4 mb-4 mt-2">Recent updates</p>
            <ul class="timeline">
                @for (update of updates; track update) {
                <li class="timeline__event">
                    @if (updates && updates.length > 0) {
                    <div class="timeline__icon">
                        @if (update.countryCode) {
                        <i class="flag flag--{{update.countryCode | lowercase}}"></i>
                        }
                        @if (!update.countryCode) {
                        <i class="fa fa-bullhorn text-info-4"></i>
                        }
                    </div>
                    }
                    @if (updates && updates.length > 0) {
                    <div class="timeline__content">
                        <div class="card">
                            <div class="card-block">
                                <div class="row">
                                    <div class="col-6">
                                        @if (update.countryName) {
                                        <h3 class="h5">
                                            {{ update?.countryName }}
                                        </h3>
                                        }
                                        @if (!update.countryName) {
                                        <h3 class="h5">
                                            Announcement
                                        </h3>
                                        }
                                    </div>
                                    <div class="col-6 text-right">
                                        @if (update.latestUpdateType == latestUpdateType.EventLatestUpdate) {
                                        <small class="text-muted">
                                            Timeline update <i class="fa fa-calendar ml-1"></i>
                                        </small>
                                        }
                                        @if (update.latestUpdateType == latestUpdateType.CategoryDetailLatestUpdate || update.latestUpdateType == latestUpdateType.CountryDashboardDescriptionLatestUpdate ) {
                                        <small class="text-muted">
                                            Content update <i class="fa fa-comment-o ml-1"></i>
                                        </small>
                                        }
                                        @if (update.latestUpdateType == latestUpdateType.GenericLatestUpdate) {
                                        <small class="text-muted">
                                            General update <i class="fa fa-comment-o ml-1"></i>
                                        </small>
                                        }
                                    </div>
                                </div>
                                <!-- External url only -->
                                @if (update.url.includes('http') || update.url.includes('https') || update.latestUpdateType == latestUpdateType.EventLatestUpdate) {
                                <div>
                                    <div class="mb-0 textBody--sm" [innerHtml]="update.description">
                                    </div>
                                    @if (update.url.includes('http') || update.url.includes('https')) {
                                    <a href="{{ update.url }}" class="textBody--xs" target="_blank">
                                        <i class="fa fa-external-link mr---xxx-small"></i>
                                        <strong>{{ update.url | truncate: ['32'] }}</strong>
                                    </a>
                                    }
                                </div>
                                }
                                <!-- Internal url -->
                                @if (update.latestUpdateType !== latestUpdateType.EventLatestUpdate && !(update.url.includes('http') || update.url.includes('https'))) {
                                <div class="mb-0 textBody--sm" [innerHtml]="update.description"></div>
                                }
                            </div>
                            <div class="card-footer p-3">
                                <div class="row">
                                    <div class="col-6">
                                        <small class="text-muted">{{  update.createdDate | date : 'dd MMMM y' }}</small>
                                    </div>
                                    @if (update.url) {
                                    <div class="col-6 text-right">
                                        @if (update.url && (update.url.includes('http') || update.url.includes('https'))) {
                                        <a href="{{ update.url }}" class="" target="_blank">
                                            <small class="text-black text-muted">View update</small> <i class="fa fa-arrow-circle-right text-info-3 ml-1"></i>
                                        </a>
                                        }
                                        @if (update.url && !(update.url.includes('http') || update.url.includes('https'))) {
                                        <a [routerLink]="[update.url]" class="">
                                            <small class="text-black text-muted">View update</small> <i class="fa fa-arrow-circle-right text-info-3 ml-1"></i>
                                        </a>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </li>
                }
            </ul>

            <no-content-message [visible]="updates && updates.length == 0" message="There are currently no updates"></no-content-message>
            @if (updates && showReadMore) {
            <div id="read-more" class="mt-4 text-center">
                <button (click)="onReadMoreClicked()" class="btn btn-info btn-inline-block btn-sm pl-5 pr-5">Read more <i class="fa fa-arrow-circle-down ml-1"></i></button>
            </div>
            }
        </div>
        <div id="mapcontainer" class="col-md-7 mt-5">
            @if (!DashboardExists) {
            <div class="alert alert-warning">Dashboard could not be initialised. Please ensure Dropdowns and Map Data has been configured.</div>
            }
            <div class="row">
                <div class="col">
                    <p class="h4 mt-2 mb-4">
                        World map
                        <a [routerLink]="['/'+mapRouteLink]"><i class="fa fa-arrow-circle-right ml-2 text-info"></i></a>
                    </p>
                </div>
            </div>

            <div class="card">
                <div class="card-header bg-info text-white">
                    <small class="m-0">
                        The following map shows:
                        @for (description of mapDescriptions; track description; let i = $index) {
                        <span>
                            <strong>
                                {{description}} @if (mapDescriptions.length > 1 && i < (mapDescriptions.length-1)) {
                                <i class="fa fa-angle-right text-white"></i>
                                }
                            </strong>
                        </span>
                        }
                        <a [routerLink]="['/'+mapRouteLink]" class="text-info-3"><strong>(change view)</strong></a>
                    </small>
                </div>
                <div class="card-block">
                    <map name="map"></map>
                </div>
                <div class="card-footer p-3">

                    @if (mapKey != undefined && mapKey.presentationTypeId == 2) {
                    <ul class="mapkey mapkey--horizontal m-0 text-center">
                        @for (item of mapKey.dropDownItems; track item) {
                        <li [value]="item.id" class="textBody--xs"><span class="mapkey__key" [ngStyle]="{'background': item.colour}"></span>{{item.text}}</li>
                        }
                    </ul>
                    }
                </div>
            </div>

            <div class="card bg-lightest-gray mt-4" *featureToggle="features.ContentIsUpToDate">
                @if (shouldShowLastUpdatedDate()) {
                <div class="card-block textBody--xs">
                    <i class="fa fa-clock-o mr-1"></i>
                    Location summary content is up-to-date as of <strong>{{lastUpdatedDate | date : 'dd MMMM y'}}</strong>
                </div>
                }
            </div>

        </div>
    </div>
</div>

<email-subscription-modal #subscription (formSubmit)="onFormSubmit($event)" [countryData]="modalCountries" id="emailSubscriptionModal"></email-subscription-modal>